import { Component, input } from '@angular/core';
import { provideIcons, NgIcon } from '@ng-icons/core';
import { DOCUMENTS_ICONS } from './definitions';
import { FileResponse } from '../../../../core/clients/omni-core/models';
import { TooltipDirective } from 'excellence-ui';

@Component({
  selector: 'app-document-icon',
  templateUrl: './document-icon.html',
  providers: [provideIcons(DOCUMENTS_ICONS)],
  imports: [NgIcon, TooltipDirective],
})
export class DocumentIcon {
  file = input.required<FileResponse>();
  size = input.required<number>();
}
